import React from 'react'
import styles from './SidePannelShimmer.module.css'
const SidePannelShimmer = ({ width = '100%', height = '20px', borderRadius = '4px', style = {} }) => {
    return (
      <div
        className={styles.shimmerWrapper}
        style={{ width, height, borderRadius, ...style }}
      >
        <div className={styles.shimmer}></div>
      </div>
    );
  };
  

export default SidePannelShimmer